// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeUploadStep-FooterButton_cls1__N-kVZ","cls2":"PayeeUploadStep-FooterButton_cls2__8ddy6 PayeeUploadStep-FooterButton_cls1__N-kVZ"};